
















































import ConnectWalletNetworkBadge from '@/components/walletConnection/ConnectWalletNetworkBadge.vue'
import {TWalletNetwork} from '@/model/wallets/types/WalletNetwork'
import {Vue, Component, Prop} from 'vue-property-decorator'
import {NetworkNamespace} from '@/enums/NetworkNamespace'

@Component({
  components: {ConnectWalletNetworkBadge},
  computed: {
    NetworkNamespace() {
      return NetworkNamespace
    },
  },
})
export default class ConnectWalletOnegate extends Vue {
  @Prop({type: String, required: true})
  networkNamespace!: NetworkNamespace
  @Prop({type: String, default: undefined}) targetNetwork?: TWalletNetwork

  returnToChooseWallet() {
    this.$emit('return-page')
  }
}
